import { render, staticRenderFns } from "./ToggleBox.vue?vue&type=template&id=6010e113&scoped=true&"
import script from "./ToggleBox.vue?vue&type=script&lang=js&"
export * from "./ToggleBox.vue?vue&type=script&lang=js&"
import style0 from "./ToggleBox.vue?vue&type=style&index=0&id=6010e113&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6010e113",
  null
  
)

export default component.exports